class FaqHandler {
  constructor(faqData, defaultCategory) {
    this.faq = faqData

    this.searchParams = new URLSearchParams(window.location.search)
    const category = this.searchParams.get('category')
    this.defaultCategory = category || defaultCategory?.toLowerCase() || null

    this.categorySet = new Set()
    this.categorySection = document.getElementById('categories')
    this.faqSelect = document.getElementById('faq-select')
    this.faqSection = document.getElementById('faq')

    if (this.categorySection) {
      this.generateCategories()
    }

    if (this.faqSelect) {
      this.handleFaqSelect()
    }

    this.defaultCategory
      ? this.filterFaq(this.defaultCategory)
      : this.generateFaq(this.faq)
  }

  generateCategories() {
    if (!this.categorySection) {
      console.error('Id "categories" is not found')
      return
    }

    if (!this.categorySet.length) {
      this.faq.forEach(item =>
        item.categories.forEach(cat => this.categorySet.add(cat))
      )
    }

    Array.from(this.categorySet).forEach(cat => {
      const button = document.createElement('a')
      button.classList.add('btn')
      button.dataset.filter = cat.toLowerCase()
      button.href = '#'
      button.textContent = cat.replace(/-/g, ' ')
      button.onclick = e => {
        e.preventDefault()
        this.filterFaq(e.target.textContent.toLowerCase().replace(/ /g, '-'))
        document
          .querySelectorAll('[data-filter]')
          .forEach(catBtn => catBtn.classList.remove('selected'))
        e.target.classList.add('selected')
      }

      this.categorySection.appendChild(button)
    })
  }

  generateFaq(faqData) {
    if (!this.faqSection) {
      console.error('Section with id "faq" is not found')
    }

    this.faqSection.innerHTML = ''

    faqData.forEach((item, index) => {
      const faqItem = document.createElement('div')
      faqItem.classList.add('faq-item')

      const question = document.createElement('h4')
      question.classList.add('faq-item__question')
      question.setAttribute('data-question', item.question)
      question.textContent = item.question

      const videos = document.querySelectorAll('video')
      const iframes = document.querySelectorAll('iframe')

      question.onclick = e => {
        e.preventDefault()
        const prevOpenedList = document.querySelectorAll('.faq-item.is-open')

        if (prevOpenedList.length) {
          prevOpenedList.forEach(faq => {
            faq !== faqItem && faq.classList.remove('is-open')
          })
        }

        faqItem.classList.toggle('is-open')

        // pause all html5 and youtube videos
        videos.forEach(video => video.pause())
        iframes.forEach(iframe => {
          const iframeSrc = iframe.src
          iframe.src = iframeSrc
        })

        const rect = faqItem.getBoundingClientRect()
        const offset = rect.top + window.scrollY - 50
        
        window.requestAnimationFrame(() => {
          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          })
        })
      }

      const answer = document.createElement('div')
      answer.classList.add('faq-item__answer')

      let modifedAnswer = this.modifyAnswer(item)

      answer.innerHTML = modifedAnswer
      faqItem.append(question, answer)

      if (index === 0) {
        // Uncomment if you want the first item to be open by default
        // faqItem.classList.add('is-open');
      }

      this.faqSection.appendChild(faqItem)
    })

    const selectedCategory = document.querySelector(
      `[data-filter="${this.defaultCategory}"]`
    )
    if (selectedCategory) {
      selectedCategory?.classList.add('selected')

      const selectedQuestion = this.searchParams.get('question');
      
      if (selectedQuestion) {
        const question = document.querySelector(`[data-question="${selectedQuestion}"]`)
        setTimeout(() => {
          question?.click()
        }, 200)
      }

    }

    // this.scrollToFaqSection();
    // when we are on mobile we need to hide the #categories on category selection
  }

  generateSelect() {
    if (!this.faqSelect) {
      console.error('Id "faq-select" is not found')
      return
    }

    if (!this.categorySet.length) {
      this.faq.forEach(item =>
        item.categories.forEach(cat => this.categorySet.add(cat))
      )
    }

    this.faqSelect.innerHTML = Array.from(this.categorySet)
      .map(
        cat =>
          `<option value="${cat.toLowerCase()}">${cat.replace(
            /-/g,
            ' '
          )}</option>`
      )
      .join('')
     
  }

  handleFaqSelect() {
    this.generateSelect()

    if (this.defaultCategory) {
      this.faqSelect.value = this.defaultCategory;
      this.filterFaq(this.defaultCategory)
    }

    this.faqSelect.addEventListener('change', e => {
      this.filterFaq(e.target.value)
    })
  }

  scrollToFaqSection() {
    const faqSection = document.getElementById('section-faq')

    // scroll into view
    if (faqSection) {
      faqSection.scrollIntoView({
        behavior: 'instant'
      })
    }
  }

  modifyAnswer(item) {
    let videoWrapper = ''
    let answ = item.answer
    let video = item.video

    if (video) {
      if (this.isYoutubeLink(video)) {
        const videoId = this.getYoutubeVideoID(video)
        videoWrapper = `<div class="faq-video"><iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" loading="lazy" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`
      } else {
        videoWrapper = `<div class="faq-video"><video controls><source src="${video}" type="video/mp4">Your browser does not support the video tag.</video></div>`
      }
    }

    if (answ.includes('[video]')) {
      answ = answ.replace('[video]', videoWrapper)
    }

    return answ
  }

  isYoutubeLink(url) {
    return url.match(/^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/)
  }

  getYoutubeVideoID(url) {
    const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
    const result = url.match(regex)
    return result && result[2].length === 11 ? result[2] : null
  }

  filterFaq(category) {
    const filteredFaq = this.faq.filter(item =>
      item.categories.includes(category)
    )

    this.generateFaq(filteredFaq)
  }
}

// Usage
new FaqHandler(window?.faq || [], 'overview-,-assembly-&-getting-started')
